import React, { Component } from 'react';
import styled from 'styled-components/macro';
import { Field, reduxForm } from 'redux-form';
import { renderField } from '../../../form_helpers';
import { changePassword, changePasswordReset } from '../../../actions';
import { connect } from 'react-redux';
import MyS4CAPIErrorAlert from '../alerts/MyS4CAPIErrorAlert';
import { toast } from 'react-toastify';
import { PATH_AUTHENTICATED_REDIRECT } from '../../../constants';
import { CHANGE_PWORD_ERROR } from '../../../actions/types';
import { Button as ButtonV2 } from '../../../v2/components/button/Button';

const submit = (values, dispatch, props) => {
  if (
    props.email &&
    props.code &&
    values.new_password &&
    values.confirm_new_password &&
    values.new_password === values.confirm_new_password
  ) {
    props.errorMsg = {};

    const code = props.code.replace(/\D/g, '').substring(0, 6);
    props.changePassword(props.email, code, values.new_password);
  }
};

const validate = (values, props) => {
  const errors = {};

  if (!values.new_password) {
    errors.new_password = props.strings.required;
  }

  if (values.new_password && values.new_password.length < 6) {
    errors.new_password = props.strings.passwordLength;
  }

  if (!values.confirm_new_password) {
    errors.confirm_new_password = props.strings.required;
  }

  if (
    values.new_password &&
    values.confirm_new_password &&
    values.new_password !== values.confirm_new_password
  ) {
    errors.confirm_new_password = props.strings.match;
  }

  return errors;
};

class updatePasswordForm extends Component {
  componentDidMount = () => {
    this.props.changePasswordReset();
  };

  componentWillUnmount() {
    this.props.changePasswordReset();
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.curLang !== this.props.curLang) {
      this.props.reset();
    }
    if (
      nextProps.success === true &&
      nextProps.success !== this.props.success
    ) {
      toast.success(this.props.strings.updatePasswordSuccess, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      this.props.reset();
    }
    if (nextProps.isAuthenticated && nextProps.success === true) {
      // Delay redirect until authentication complete
      this.props.changePasswordReset();
      this.props.history.push(PATH_AUTHENTICATED_REDIRECT);
    }
  };

  render() {
    const { handleSubmit, submitting, pristine, strings, errorMsg } =
      this.props;
    const trans = strings;

    return (
      <div className="form form--no-btm-pad">
        <header className="form__header">
          <FormInstruct>{trans.changePassword}</FormInstruct>
        </header>
        {/* Possibly be should some kind of loading logo here as experiencing latency */}
        <form className="form__form" onSubmit={handleSubmit(submit)}>
          <Field
            name="new_password"
            type="password"
            component={renderField}
            label={trans.newPassword}
            autoFocus={true}
          />
          <Field
            name="confirm_new_password"
            type="password"
            component={renderField}
            label={trans.confirmPassword}
          />

          <MyS4CAPIErrorAlert
            errorMessage={errorMsg}
            errorType={CHANGE_PWORD_ERROR}
          />
          <FormActions>
            <ButtonV2
              onClick={handleSubmit(submit)}
              label={trans.updatePassword}
              size="large"
              disabled={pristine || submitting}
            />
            <ButtonSubmit aria-hidden="true" />
          </FormActions>
        </form>
      </div>
    );
  }
}

const FormInstruct = styled.div`
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.blackFull
      : props.theme.color.whiteFull};
  font-size: 20px;
  line-height: 24px;
`;

const FormActions = styled.div`
  display: flex;
  margin: 11px 20px 30px;
  justify-content: center;
`;

const ButtonSubmit = styled.button`
  position: absolute;
  left: -9999px;
`;

updatePasswordForm = reduxForm({
  form: 'changePassword',
  validate,
})(updatePasswordForm);

updatePasswordForm = connect(
  (state) => ({
    curLang: state.curLang,
    success: state.changePassword.success,
    errorMsg: state.changePassword.error,
  }),
  { changePassword, changePasswordReset } // bind account loading action creator
)(updatePasswordForm);

export default updatePasswordForm;
